import {createFeature, createReducer, on} from '@ngrx/store';
import {OrderDetailsActions} from './order-details.actions';
import {Sale} from 'app/data/models/sale';

export const ORDER_DETAILS_FEATURE_KEY = 'orderDetails';

export interface OrderDetailsState {
  order: Sale | undefined;
}

export const initialOrderDetailsState: OrderDetailsState = {
  order: undefined,
};

export const orderDetailsReducer = createReducer(
  initialOrderDetailsState,

  on(OrderDetailsActions.loadOrder, state => ({...state, order: undefined})),

  on(OrderDetailsActions.loadOrderSuccess, (state, {order}) => {
    return {...state, order};
  })
);

export const orderDetailsFeature = createFeature({
  name: ORDER_DETAILS_FEATURE_KEY,
  reducer: orderDetailsReducer,
});

export const {name, reducer, selectOrder} = orderDetailsFeature;
